import { BsGem, BsHeart, BsAward, BsStar } from 'react-icons/bs';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#ffffff] via-[#ffffff] to-[#ffffff] py-8 px-4">
      <div className="max-w-6xl mx-autob mt-16">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            אודות SHA-SHA
          </h1>
          <p className="text-secondary text-xl">
            תכשיטים יוקרתיים בעבודת יד עם אהבה ומקצועיות
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {/* בעלת העסק */}
        <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-8 mb-12 border border-[#3a3a3a]">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-3xl font-bold text-brown mb-6">
                נטלי בדש - הצורפת והבעלים
              </h2>
              <div className="space-y-4 text-secondary text-lg leading-relaxed">
                <p>
                  שלום, אני נטלי בדש, צורפת מקצועית עם למעלה מ-15 שנות ניסיון בעיצוב וייצור תכשיטים יוקרתיים. 
                  התשוקה שלי לתכשיטים החלה בילדותי, כשראיתי את סבתי עובדת עם פלדת אל חלד יוקרתי ואבנים יקרות.
                </p>
                <p>
                  למדתי צורפות במכון הטכנולוגי חולון והתמחיתי בעבודת יד מסורתית המשלבת טכניקות מודרניות. 
                  כל תכשיט שאני יוצרת נושא את החתימה האישית שלי - שילוב של אלגנטיות קלאסית עם עיצוב עכשווי.
                </p>
                <p>
                  אני מאמינה שתכשיט הוא לא רק אביזר אופנה, אלא ביטוי של רגש, זיכרון וזהות. 
                  לכן כל תכשיט נוצר בקפידה, עם תשומת לב לכל פרט ופרט.
                </p>
              </div>
            </div>
            <div className="text-center">
              <div className="w-64 h-64 bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-full mx-auto flex items-center justify-center mb-6">
                <BsGem className="w-32 h-32 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-brown mb-2">נטלי בדש</h3>
              <p className="text-secondary">צורפת מקצועית ובעלת SHA-SHA</p>
            </div>
          </div>
        </div>

        {/* הסיפור שלנו */}
        <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-8 mb-12 border border-[#8b6f7c]">
          <h2 className="text-3xl font-bold text-brown mb-6 text-center">
            הסיפור שלנו
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4 text-primary text-lg leading-relaxed">
              <p>
                SHA-SHA נולדה מתוך אהבה עמוקה לתכשיטים ורצון ליצור משהו מיוחד. 
                השם SHA-SHA נבחר כי הוא מייצג את הצליל של תכשיטים מתנגשים - צליל שמזכיר לנו את היופי והקסם של תכשיטים.
              </p>
              <p>
                התחלנו כסדנה קטנה ב-2010, ויצרנו תכשיטים מותאמים אישית עבור לקוחות פרטיים. 
                עם הזמן, הבקשות גדלו והחלטנו להרחיב את הפעילות לחנות מקוונת.
              </p>
            </div>
            <div className="space-y-4 text-primary text-lg leading-relaxed">
              <p>
                היום, SHA-SHA היא מותג מוכר ואהוב, המשלב מסורת צורפות עתיקה עם טכנולוגיה מודרנית. 
                כל תכשיט נוצר בעבודת יד בסטודיו שלנו, עם חומרים איכותיים ותשומת לב לפרטים.
              </p>
              <p>
                אנחנו מאמינים באיכות, יושרה ואהבה למקצוע. 
                כל תכשיט שאנחנו יוצרים נושא את החתימה האישית שלנו ואת המחויבות שלנו למצוינות.
              </p>
            </div>
          </div>
        </div>

        {/* הערכים שלנו */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-6 text-center border border-[#8b6f7c] hover:border-accent transition-all duration-300 transform hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-r from-[#9a624b] to-[#ac609c] rounded-full flex items-center justify-center mx-auto mb-4">
              <BsGem className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-brown mb-2">איכות</h3>
            <p className="text-primary">חומרים איכותיים ועבודת יד מקצועית</p>
          </div>
          
          <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-6 text-center border border-[#8b6f7c] hover:border-accent transition-all duration-300 transform hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-r from-[#9a624b] to-[#ac609c] rounded-full flex items-center justify-center mx-auto mb-4">
              <BsHeart className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-brown mb-2">אהבה</h3>
            <p className="text-primary">כל תכשיט נוצר עם אהבה ותשוקה</p>
          </div>
          
          <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-6 text-center border border-[#8b6f7c] hover:border-accent transition-all duration-300 transform hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-r from-[#9a624b] to-[#ac609c] rounded-full flex items-center justify-center mx-auto mb-4">
              <BsAward className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-brown mb-2">מקצועיות</h3>
            <p className="text-primary">+ שנות ניסיון בצורפות</p>
          </div>
          
          <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-6 text-center border border-[#8b6f7c] hover:border-accent transition-all duration-300 transform hover:scale-105">
            <div className="w-16 h-16 bg-gradient-to-r from-[#9a624b] to-[#ac609c] rounded-full flex items-center justify-center mx-auto mb-4">
              <BsStar className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-xl font-bold text-brown mb-2">ייחודיות</h3>
            <p className="text-primary">עיצובים ייחודיים ומותאמים אישית</p>
          </div>
        </div>

        {/* פרטי יצירת קשר */}
        <div className="bg-gradient-to-br from-[#ffffff] to-[#ffffff] rounded-2xl shadow-2xl p-8 border border-[#8b6f7c]">
          <h2 className="text-3xl font-bold text-brown mb-6 text-center">
            יצירת קשר
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-bold text-brown mb-4">פרטי העסק</h3>
              <div className="space-y-3 text-primary">
                <p><strong className="text-highlight">בעלים:</strong> נטלי בדש</p>
                <p><strong className="text-highlight">כתובת:</strong> רחוב ירושלים 27, עפולה</p>
                <p><strong className="text-highlight">טלפון:</strong> 053-3332127</p>
                <p><strong className="text-highlight">אימייל:</strong> nataly@sha-sha.co.il</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold text-brown mb-4">שעות פעילות</h3>
              <div className="space-y-2 text-primary">
                <p><strong className="text-highlight">א-ה:</strong> 09:00-19:00</p>
                <p><strong className="text-highlight">ו:</strong> 09:00-14:00</p>
                <p><strong className="text-highlight">שבת:</strong> סגור</p>
                <p><strong className="text-highlight">חנות מקוונת:</strong> 24/7</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 